module.exports = __webpack_public_path__ + "static/img/info-bg1.8aeb8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/info-bg1.png
// module id = K3OS
// module chunks = 0